var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTraining = function SvgTraining(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 21 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00003 10.18V12.99C3.00003 13.72 3.40003 14.4 4.04003 14.75L9.04003 17.48C9.64003 17.81 10.36 17.81 10.96 17.48L15.96 14.75C16.6 14.4 17 13.72 17 12.99V10.18L10.96 13.48C10.36 13.81 9.64003 13.81 9.04003 13.48L3.00003 10.18ZM9.04003 0.520029L0.610029 5.12003C-0.0799707 5.50003 -0.0799707 6.50003 0.610029 6.88003L9.04003 11.48C9.64003 11.81 10.36 11.81 10.96 11.48L19 7.09003V13C19 13.55 19.45 14 20 14C20.55 14 21 13.55 21 13V6.59003C21 6.22003 20.8 5.89003 20.48 5.71003L10.96 0.520029C10.6646 0.362454 10.3349 0.280029 10 0.280029C9.66518 0.280029 9.33548 0.362454 9.04003 0.520029Z",
    fill: "black",
    fillOpacity: 0.7
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTraining, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/training.842f7208.svg";
export { ForwardRef as ReactComponent };